import { SettingStatus } from '@dataTypes/settingStatus.type'

export const ADJUSTMENT_FILTERS: Record<string, string[]> = {
  category: ['Adjustment', 'Collection'],
  modifier: ['Positive', 'Negative'],
  status: [SettingStatus.Enabled, SettingStatus.Disabled],
}

export const ADJUSTMENT_FILTER_LABELS: Record<string, string> = {
  category: 'Category',
  modifier: 'Modifier',
  status: 'Status',
}

export const DISCOUNT_FILTERS: Record<string, string[]> = {
  status: [SettingStatus.Enabled, SettingStatus.Disabled],
}

export const DISCOUNT_FILTER_LABELS: Record<string, string> = {
  status: 'Status',
}
